import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AnimeCard from "@/components/feature/AnimeCard";
import Hero from "./components/Hero";
import {
  CategorySection,
  HotSection,
  ScrollRow,
  RankingSection,
  FaqSection,
} from "./components/Sections";
import { animeList } from "@/mocks/anime";

function GuomanSection() {
  const guoman = animeList.filter((a) => a.category === "国漫");
  return (
    <section className="bg-background-100/60 py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <p className="mb-1 text-xs tracking-wide text-accent-400">国产动画崛起</p>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
              国漫专区
            </h2>
          </div>
          <Link
            to="/library?cat=%E5%9B%BD%E6%BC%AB"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 hover:text-primary-300"
          >
            查看更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {guoman.map((a) => (
            <AnimeCard key={a.id} anime={a} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CtaBanner() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14">
      <div className="relative overflow-hidden rounded-2xl border border-primary-800/40">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20anime%20sky%20with%20shooting%20stars%20and%20floating%20lanterns%20over%20a%20night%20town%2C%20warm%20purple%20pink%20and%20gold%20glow%2C%20dreamy%20cinematic%20background&width=1600&height=500&seq=cta-sakura-night&orientation=landscape"
          alt="樱花看番 星空下的追番之夜"
          title="樱花看番 追番之夜"
          className="h-52 w-full object-cover object-top md:h-64"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/60 to-background-950/30" />
        <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10">
          <h3 className="font-heading text-2xl text-foreground-950 md:text-4xl">
            今晚，想看点什么？
          </h3>
          <p className="mt-2 max-w-lg text-sm text-foreground-600 md:text-base">
            动画、剧场版、OVA、泡面番、国漫……樱花看番番剧库全收录，点开即看全集。
          </p>
          <div className="mt-5 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/library"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-play-circle-fill text-lg" />
              开始看番
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  useEffect(() => {
    document.title =
      "樱花看番 - 番剧库全收录 | 动画/剧场版/OVA/泡面番/国漫在线";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "樱花看番番剧库全收录，涵盖动画、剧场版、OVA、泡面番及国漫全类型。点开即看动画全集，剧场版与OVA同步更新，找番更方便。"
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <HotSection />
        <ScrollRow eyebrow="影院级体验" title="剧场版 · 同步更新" cat="剧场版" to="/library?cat=%E5%89%A7%E5%9C%BA%E7%89%88" />
        <ScrollRow eyebrow="三分钟轻松看" title="泡面番 · 下饭神器" cat="泡面番" to="/library?cat=%E6%B3%A1%E9%9D%A2%E7%95%AA" />
        <GuomanSection />
        <ScrollRow eyebrow="番外特别篇" title="OVA · 补全追番版图" cat="OVA" to="/library?cat=OVA" />
        <RankingSection />
        <CtaBanner />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}